import { createUseStyles } from 'react-jss';
import { color, fontSize, spacing } from '@blink/components';

export const useLeverageFactorStyle = createUseStyles({
    leverageHeader: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: spacing['05'],

        '& p': {
            fontSize: fontSize.md,
            fontWeight: '600',
            margin: '0',
        },
    },
    percentageWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    leveragePercentage: {
        border: `1px solid ${color.border.opaque}`,
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        maxWidth: '110px',
        minWidth: '110px',

        '& p': {
            fontSize: '14px',
            fontWeight: '500',
            padding: '5px 0',
            margin: '0 2px',
            userSelect: 'none',
        },
        '& button': {
            padding: '5px 10px',
            fontSize: fontSize.lg,
            fontWeight: '500',
            border: 'none',
        },
    },
    leveragePercentageSlider: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        marginLeft: spacing['04'],
    },
    slider: {
        width: '100%',
        height: '4px',
        borderRadius: '4px',
        appearance: 'none',
        outline: 'none',
        transition: 'all 0.2s',
        cursor: 'pointer',

        '&:hover .ant-slider-track': {
            backgroundColor: color.background.accent,
        },
        '& .ant-slider-track': {
            backgroundColor: color.background.accent,
        },
        '& .ant-slider-handle::after': {
            backgroundColor: color.background.accent,
            boxShadow: 'none',
        },
    },
    leveragePredefinedValues: {
        marginTop: spacing['05'],
        display: 'flex',
        justifyContent: 'space-between',

        '& #values': {
            borderRadius: '4px',
            padding: '8px 12px',
            fontSize: fontSize.md,
            fontWeight: '500',
            flex: 0.22,
            border: `1px solid transparent !important`,

            '&:hover': {
                border: `1px solid ${color.border.accent} !important`,
                backgroundColor: `${color.content.lightAccent}!important`,
                color: color.content.accent,
            },
        },
    },
    activeButton: {
        border: `1px solid ${color.border.accent}`,
        backgroundColor: `${color.content.lightAccent}!important`,
        color: color.content.accent,
    },
    textBtn: {
        color: color.content.accent,
        cursor: 'pointer',
    },
});
